module.exports = __webpack_public_path__ + "static/media/chicken1.01c28724.jpg";